// ink-component
import React, { ReactNode } from 'react';

import { bemHelper } from '../../helpers';

import useDeprecatedWarning from '../../hooks/useDeprecatedWarning';
import getGlobalProps from '../../helpers/constants/global-props';

export interface StafferProps {
  /** Staff element that should be displayed and tagged when staff */
  children: ReactNode;
  /** Additional condition on top of being staff */
  when?: any;
  /** Puts the staff label outside the border */
  tagOut?: boolean;
  /** Forces border to wrap around the element */
  isInline?: boolean;
  /** Removes the yellow border and just the bubble */
  isInvisible?: boolean;
  /** Marks the element with a given ID to make it easier to select in tests */
  'data-testid'?: string | number;
  /** @ignore */
  bubbleOnly?: boolean;
}

const globalProps = getGlobalProps({ deprecated: true });

/**
 * @purpose Wraps around elements to display staff only elements
 * @staffonly true
 * @categories accessory
 * @deprecated This component is deprecated and replaced by [StaffOutliner](https://ink.carta.com/components/StaffOutliner/)
 * @status deprecated
 * @replacementComponent StaffOutliner
 * @dateOfDeletion December 1st, 2023
 */
function Staffer(props: StafferProps) {
  useDeprecatedWarning({ componentName: 'Staffer', substitute: 'StaffOutliner' });

  const { when, children, tagOut, isInline, bubbleOnly, isInvisible } = props;

  if (!when) return null;

  function defineClassName() {
    const b = bemHelper();

    return b('ink-staffer', {
      outer: tagOut,
      inline: isInline,
      'bubble-only': bubbleOnly,
      invisible: isInvisible,
    });
  }

  return (
    <div className={defineClassName()} data-testid={props['data-testid']} {...globalProps}>
      {children}
    </div>
  );
}

Staffer.defaultProps = {
  when: true,
  tagOut: false,
  isInline: false,
  isInvisible: false,
};

Staffer.displayName = 'Staffer';

export default Staffer;
